import { Billing } from "@/features/settings/billing";

export const Route = createFileRoute({
  component: Billing,
});
